import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/shared/data/data.service';
import { CartService } from '../../../../shared/services/cart.service';
import gsap from 'gsap';

@Component({
  selector: 'app-navbar-style-two',
  templateUrl: './navbar-style-two.component.html',
  styleUrls: ['./navbar-style-two.component.scss']
})
export class NavbarStyleTwoComponent implements OnInit {
  isLoading: boolean = false;
  showCart: boolean = false;
  cartItems: any[] = [];
  cartItemCount: number = 0;
  showCheckout = false;
  orderData: any;
  isMobileMenuOpen: boolean = false;
  isSticky: boolean = false;


  @ViewChild('particles')
  canvas!: ElementRef<HTMLCanvasElement>;

  @ViewChild('logo')
  logo!: ElementRef;

  ctx!: CanvasRenderingContext2D;

  particles: any[] = [];

  constructor(private fb: FormBuilder,
    public data: DataService,
    private http: HttpClient,
    private cartService: CartService,
    private router: Router,

  ) {

    this.enquiryForm = this.fb.group({
      lead_name: ['', [Validators.required]],
      // contact_phone: ['', [Validators.required,Validators.pattern("^[0-9]{10}$")]],
      contact_phone: ['', [
        Validators.required,
        Validators.pattern('^[3-7][0-9]{7}$')
      ]],
      contact_email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      customer_type: ['', [Validators.required]],
      delivery_location: ['', [Validators.required]],
      scope_of_project: [''],
      created_by: ['1'],
      source: ['10'],
      status: ['1'],
    });
  }

  public enquiryForm!: FormGroup;
  url: string = '';
  currentPlaceholder: string = 'Search here...';
  private currentIndex: number = 0;

  // Interval reference for cleanup
  private placeholderInterval: any;
  private currentPhrase: string = '';

  // Index tracking for phrases
  private currentPhraseIndex: number = 0;

  // Index tracking for characters in current phrase
  private currentCharIndex: number = 0;

  // Whether we're currently typing or erasing
  private isTyping: boolean = true;

  // Interval references for cleanup
  private typingInterval: any;

  // Speeds for typing and erasing (in milliseconds)
  private typingSpeed: number = 100;
  private erasingSpeed: number = 50;
  private pauseBeforeErasing: number = 2000;
  private pauseBeforeTyping: number = 500;

  // Search term
  searchTerm: string = '';

  // Search term
  placeholders: string[] = [
    'Search for Fireclass...',
    'Search for Detection (ASD)...',
    'Search for Aspirating Smoke...',
    'Search for Linear Heat Detection...',
    'Search for PAVA...',
    'Search for FM 200...',
    'Search for Fire Alarm...'
  ];


  ngOnInit(): void {
    this.startTyping();

    // Subscribe to cart service
    this.cartService.cartItems$.subscribe(items => {
      this.cartItems = items;
    });

    this.cartService.cartItemCount$.subscribe(count => {
      this.cartItemCount = count;
    });

    // Add scroll listener for sticky navbar
    window.addEventListener('scroll', this.onWindowScroll, true);
  }

  classApplied = false;
  toggleClass() {
    this.classApplied = !this.classApplied;
  }
  startTyping(): void {
    this.currentPhrase = this.placeholders[this.currentPhraseIndex].replace("Search for ", ""); // Remove "Search for " from the phrases
    this.currentPlaceholder = "Search for "; // Ensure the prefix stays static
    this.animateText();
  }

  animateText(): void {
    if (this.isTyping) {
      // Typing forward
      this.typingInterval = setTimeout(() => {
        this.currentPlaceholder = "Search for " + this.currentPhrase.substring(0, this.currentCharIndex + 1);
        this.currentCharIndex++;

        if (this.currentCharIndex < this.currentPhrase.length) {
          this.animateText();
        } else {
          // Finished typing, pause before erasing
          this.isTyping = false;
          setTimeout(() => {
            this.animateText();
          }, this.pauseBeforeErasing);
        }
      }, this.typingSpeed);
    } else {
      // Erasing
      this.typingInterval = setTimeout(() => {
        this.currentPlaceholder = "Search for " + this.currentPhrase.substring(0, this.currentCharIndex);
        this.currentCharIndex--;

        if (this.currentCharIndex >= 0) {
          this.animateText();
        } else {
          // Finished erasing, move to next phrase
          this.isTyping = true;
          this.currentPhraseIndex = (this.currentPhraseIndex + 1) % this.placeholders.length;
          this.currentPhrase = this.placeholders[this.currentPhraseIndex].replace("Search for ", ""); // Remove prefix for animation

          // Pause before typing next phrase
          setTimeout(() => {
            this.animateText();
          }, this.pauseBeforeTyping);
        }
      }, this.erasingSpeed);
    }
  }
  addlead() {

    this.isLoading = true;
    if (this.enquiryForm.invalid) {
      this.enquiryForm.markAllAsTouched();
      this.isLoading = false;
      return;
    }

    if (this.enquiryForm.valid) {
      const leadData = this.enquiryForm.value;

      this.url = this.data.base_url + 'addlead/';

      const formData = new FormData();

      // Object.keys(leadData).forEach((key) => {
      //     if(leadData[key]!='' && leadData[key]!=undefined)
      //     {
      //       formData.append(key, leadData[key]);
      //     }
      //   });

      Object.keys(leadData).forEach((key) => {
        // ❌ skip unwanted fields
        if (key === 'customer_type' || key === 'delivery_location') {
          return;
        }

        if (leadData[key] != '' && leadData[key] != undefined) {
          formData.append(key, leadData[key]);
        }
      });
      this.http.post(this.url, formData).subscribe({
        next: (response: any) => {
          console.log('Response from server:', response);
          alert('Thanks For Your Enquiry');
          window.location.reload();
        },
        error: (error: any) => {
          this.isLoading = false;
          console.error('Error:', error);

        },
        complete: () => {
          console.log('Request complete');
          this.isLoading = false;
        },
      });
    }

  }

  ngOnDestroy(): void {
    // Clear interval when component is destroyed to prevent memory leaks
    if (this.typingInterval) {
      clearInterval(this.typingInterval);
    }
    // Remove scroll listener
    window.removeEventListener('scroll', this.onWindowScroll, true);
  }

  onWindowScroll = (): void => {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    this.isSticky = scrollPosition > 50;
  }

  // =====================================
  // CART FUNCTIONALITY
  // =====================================

  toggleCart(): void {
    this.showCart = !this.showCart;
  }

  updateCartItems(items: any[]): void {
    this.cartItems = items;
    this.cartItemCount = items.reduce((total, item) => total + item.quantity, 0);
  }


  openCheckout(data: any) {
    this.orderData = data;
    this.showCheckout = true;
  }


  isLoggedIn(): boolean {
    return localStorage.getItem('is_logged_in') === 'true';
  }

  getUserName(): string {
    return localStorage.getItem('customer_name') || '';

  }
  getUserImage(): string {
    return localStorage.getItem('profile_image') || '';
  }

  logout() {
    localStorage.clear();
    window.location.href = '/';
  }

  customerTypes = [
    { id: 1, value: "Agriculture & Farming" },
    { id: 8, value: "Consulting & Professional Services" },
    { id: 10, value: "Defence & Security" },
    { id: 12, value: "Education & Training" },
    { id: 16, value: "Entertainment & Media" },
    { id: 18, value: "Food & Beverage" },
    { id: 20, value: "Healthcare & Hospitals" },
    { id: 21, value: "Hospitality & Tourism" },
    { id: 23, value: "Insurance" },
    { id: 25, value: "Logistics & Transportation" },
    { id: 28, value: "Oil & Gas" },
    { id: 29, value: "Pharmaceuticals & Life Sciences" },
    { id: 31, value: "Printing & Packaging" },
    { id: 32, value: "Recycling & Waste Management" },
    { id: 33, value: "Retail & Wholesale" },
    { id: 34, value: "Shipping & Marine" },
    { id: 35, value: "Telecommunications" },
    { id: 38, value: "Warehousing & Supply Chain" },
    { id: 39, value: "Wellness & Fitness" },
    { id: 40, value: "Other (Specify)" },
    { id: 7, value: "Real Estate" },
    { id: 19, value: "Government Sector" },
    { id: 3, value: "Facility Management" },
    { id: 2, value: "MEP Contractors" },
    { id: 13, value: "Fit Out Contractors" },
    { id: 14, value: "END User" },
    { id: 4, value: "Banking & Financial Service" },
    { id: 15, value: "Fire Contractor" }
  ];

  goToCart() {
    this.router.navigate(['/cart-section']);
  }

  // =====================================
  // MOBILE MENU
  // =====================================

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    document.body.style.overflow = this.isMobileMenuOpen ? 'hidden' : '';
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
    document.body.style.overflow = '';
  }





  ngAfterViewInit() {

    this.initCanvas();

    this.animateOrbit();

    this.animateGlow();

    // this.createParticles();

  }

  initCanvas() {

    const canvas = this.canvas.nativeElement;

    canvas.width = 120;

    canvas.height = 120;

    this.ctx = canvas.getContext('2d')!;

  }

  animateOrbit() {

    gsap.to(".orbit", {

      rotation: 360,

      duration: 4,

      repeat: -1,

      ease: "none"

    });

  }

  animateGlow() {

    gsap.to(this.logo.nativeElement, {

      // filter:"drop-shadow(0 0 12px gold) drop-shadow(0 0 35px orange)",

      repeat: -1,

      yoyo: true,

      duration: 1.8

    });

  }

  createParticles() {

    setInterval(() => {

      this.particles.push({

        angle: Math.random() * Math.PI * 2,

        radius: 20,

        life: 1,

        speed: 0.8 + Math.random() * 1.4,

        size: 2 + Math.random() * 2

      });

    }, 80);

    requestAnimationFrame(() => this.draw());

  }

  draw() {

    const ctx = this.ctx;

    ctx.clearRect(0, 0, 120, 120);

    this.particles.forEach((p, index) => {

      p.radius += p.speed;

      p.life -= 0.015;

      const x = 60 + Math.cos(p.angle) * p.radius;

      const y = 60 + Math.sin(p.angle) * p.radius;

      ctx.beginPath();

      ctx.arc(x, y, p.size, 0, Math.PI * 2);

      // ctx.fillStyle=`rgba(255,200,40,${p.life})`;

      ctx.shadowColor = "gold";

      ctx.shadowBlur = 12;

      ctx.fill();

      if (p.life <= 0) {

        this.particles.splice(index, 1);

      }

    });

    requestAnimationFrame(() => this.draw());

  }





}
